import { useCallback, useState } from 'react';

export interface UseVisibleOutput {
  hide: () => void;
  show: () => void;
  toggle: () => void;
  isVisible: boolean;
  setIsVisible: (state: boolean) => void;
}

export const useVisible = (
  initialState?: boolean,
  disableActions?: boolean,
): UseVisibleOutput => {
  const [visible, setVisibleState] = useState(initialState || false);

  const setVisible = useCallback(
    (state: boolean) => {
      if (!disableActions) {
        setVisibleState(state);
      }
    },
    [setVisibleState, disableActions],
  );

  const hide = useCallback(() => {
    setVisible(false);
  }, [setVisible]);

  const show = useCallback(() => {
    setVisible(true);
  }, [setVisible]);

  const toggle = useCallback(() => {
    setVisible(!visible);
  }, [setVisible, visible]);

  return {
    hide,
    show,
    toggle,
    isVisible: visible,
    setIsVisible: setVisibleState,
  };
};
